import React, { Component } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { Button, message, Popconfirm, Row, Col, Dropdown, Menu } from 'antd';
import { withState } from 'recompose';
import { path, pathOr, take, reduce, omit } from 'ramda';
import { withAsyncHandlers, asyncConnect } from 'react-async-client';
import styled from 'styled-components';
import { MenuOutlined, EllipsisOutlined, PlusOutlined, ImportOutlined, ExportOutlined } from '@ant-design/icons';

import { reorder } from '../../utils/dnd';
import { patchQuestionnary } from '../../actions/asyncActions';
import { openDriverModal, openDriverSettingsModal, openImportQuestionsModal, openSurveyPreviewModal } from '../../actions/modalActions';

const Wrapper = styled.div`
    padding: 15px;
`;

const Toolbar = styled.div`
    text-align: right;
    margin-bottom: 15px;
`;

const Item = styled.div`
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    background: #fff;
    display: flex;
    ol {
        padding-left: 15px;
        margin-bottom: 0;
    }
`;

const ItemContent = styled.div`
    padding: 10px 15px 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .ant-btn-group {
        min-width: 63px;
    }
`;

const Handler = styled.div`
    display: flex;
    align-items: center;
    padding: 0 20px;
`;

class DriverActions extends Component {
    state = {
        visible: false
    };

    handleMenuClick = e => {
        if (e.key !== 'delete') {
            this.setState({ visible: false });
        }
    };

    deleteQuestion = index => {
        this.setState({ visible: false });
        this.props.patchQuestionnary.dispatch({
            id: this.props.data.id,
            delete: true,
            data: [{
                op: 'remove',
                path: `/drivers/${index}`
            }]
        });
    }

    getItemMenu = () => {
        const { data, item, index, openDriverModal, openDriverSettingsModal, openSurveyPreviewModal, patchQuestionnary } = this.props;

        return <Menu onClick={this.handleMenuClick}>
            <Menu.Item
                key='preview'
                onClick={() => openSurveyPreviewModal({
                    title: item.name,
                    survey: data.id,
                    index
                })}>
                Просмотр
            </Menu.Item>
            <Menu.Item
                key='settings'
                onClick={() => openDriverSettingsModal({
                    project: data.id,
                    question: item,
                    index,
                    variables: (data.variables || []).map(id => ({ id, name: id })),
                    patchAction: patchQuestionnary
                })}>
                Настройки
            </Menu.Item>
            <Menu.Item
                key='edit'
                onClick={() => openDriverModal({ project: data.id, question: item, index, patchAction: patchQuestionnary })}>
                Редактировать
            </Menu.Item>
            <Menu.Item key='delete' style={{ padding: 0 }}>
                <Popconfirm
                    title='Вы уверены, что хотите удалить вопрос?'
                    okText='Да'
                    cancelText='Нет'
                    placement='left'
                    onConfirm={() => this.deleteQuestion(index)}>
                    <div style={{ padding: '5px 12px' }}>Удалить</div>
                </Popconfirm>
            </Menu.Item>
        </Menu>;
    }

    handleVisibleChange = visible => {
        this.setState({ visible });
    };

    render() {
        return <Dropdown
            overlay={this.getItemMenu()}
            trigger={['click']}
            onVisibleChange={this.handleVisibleChange}
            visible={this.state.visible}
            disabled={this.props.loading}
        >
            <Button icon={<EllipsisOutlined />} style={{ marginLeft: 15 }} />
        </Dropdown>;
    }
}

class QuestionnaryDriver extends Component {
    onDragEnd = (result) => {
        if (!result.destination || (result.source.index === result.destination.index)) {
            return;
        }

        const items = reorder(
            this.props.items,
            result.source.index,
            result.destination.index
        );

        this.props.setItems(items);
        this.props.patchQuestionnary.dispatch({
            id: this.props.data.id,
            data: [{
                op: 'replace',
                path: '/drivers',
                value: items
            }]
        });
    }

    getNum = (row, index) => {
        const { items } = this.props;
        const prevNums = reduce((res, cur) => res + ((cur.questions || []).length || 1), 0, take(row, items));

        return prevNums + index + 1;
    }

    export = () => {
        const questions = this.props.items.map(item => omit(['id'], item));
        const file = new Blob([JSON.stringify(questions, null, 2)], { type: 'text/json' });

        this.link.href = URL.createObjectURL(file);
        this.link.download = 'questions.json';
        this.link.click();
    }

    render() {
        const { data, meta, openDriverModal, openImportQuestionsModal, openSurveyPreviewModal } = this.props;
        const loading = meta.pending || this.props.patchQuestionnary.meta.pending;

        return <Wrapper>
            <Toolbar>
                <Button.Group>
                    <Button
                        type='primary'
                        icon={<PlusOutlined />}
                        loading={loading}
                        onClick={() => openDriverModal({
                            project: data.id,
                            patchAction: patchQuestionnary
                        })}>
                        Добавить
                    </Button>
                    <Button
                        icon={<ImportOutlined />}
                        onClick={() => openImportQuestionsModal({
                            project: data.id,
                            patchAction: patchQuestionnary
                        })}>
                        Импорт
                    </Button>
                    <Button
                        icon={<ExportOutlined />}
                        onClick={this.export}
                        disabled={!this.props.items.length}>
                        Экспорт
                    </Button>
                    <Button onClick={() => openSurveyPreviewModal({
                        title: data.name,
                        survey: data.id,
                        main: true
                    })}>
                        Просмотр
                    </Button>
                </Button.Group>
                <a href='link' ref={node => this.link = node} download style={{ display: 'none' }}>link</a>
            </Toolbar>
            <Row gutter={8} style={{ paddingLeft: 54, paddingRight: 70, marginBottom: 10 }}>
                <Col span={5}><strong>Блок</strong></Col>
                <Col span={5}><strong>Драйвер</strong></Col>
                <Col span={14}><strong>№ Вопрос</strong></Col>
            </Row>
            { this.props.items.length ?
                <DragDropContext onDragEnd={this.onDragEnd}>
                    <Droppable droppableId='droppable'>
                        { provided =>
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}>
                                { this.props.items.map((item, index) =>
                                    <Draggable key={item.id} draggableId={item.id} index={index}>
                                        { provided =>
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                style={{ ...provided.draggableProps.style, marginBottom: 15 }}>
                                                <Item>
                                                    <Handler {...provided.dragHandleProps}>
                                                        <MenuOutlined />
                                                    </Handler>
                                                    <ItemContent>
                                                        <Row gutter={8} type='flex' align='middle' style={{ width: '100%' }}>
                                                            <Col span={5}>{ item.block }</Col>
                                                            <Col span={5}>{ item.name }</Col>
                                                            <Col span={14}>
                                                                { item.questions.length ?
                                                                    item.questions.map((question, i) =>
                                                                        <div key={`question-${i}`}>{ this.getNum(index, i) }. { question }</div>
                                                                    ) : <span>{ this.getNum(index, 0) }.</span>
                                                                }
                                                            </Col>
                                                        </Row>
                                                        <DriverActions
                                                            {...this.props}
                                                            item={item}
                                                            index={index}
                                                            loading={loading} />
                                                    </ItemContent>
                                                </Item>
                                            </div>
                                        }
                                    </Draggable>
                                )}
                                { provided.placeholder }
                            </div>
                        }
                    </Droppable>
                </DragDropContext> :
                <div style={{ textAlign: 'center' }}>Нет добавленных вопросов</div>
            }
        </Wrapper>;
    }
}

export default withState('items', 'setItems', pathOr([], ['data', 'drivers']))(
    withAsyncHandlers({
        getQuestionnary: {
            successHandler: ({ data, setItems }) => setItems(pathOr([], ['drivers'], data)),
            errorHandler: ({ data, setItems }) => setItems(pathOr([], ['drivers'], data))
        }
    })(
        asyncConnect(props => ({
            patchQuestionnary: patchQuestionnary
                .withParams(() => ({ type: 'table' }))
                .withSuccessHandler((props, action) => message.success(path(['payload', 'delete'], action) ? 'Вопрос успешно удален' : 'Вопросы успешно отредактирован'))
                .withErrorHandler((props, action) => message.success(path(['payload', 'delete'], action) ? 'Не удалось удалить вопрос' : 'Не удалось изменить вопросы'))
                .withOptions({ resetOnUnmount: true })
        }), null,
        { openDriverModal, openDriverSettingsModal, openImportQuestionsModal, openSurveyPreviewModal }
    )(QuestionnaryDriver))
);
